(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var getHeaderRoot = function () { return document.querySelector('.section-header'); };
  var getHeaderRuntimeKey = function () {
    var root = getHeaderRoot();
    return root && root.id ? root.id : 'as-header-runtime';
  };

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor(){ super(); }
      connectedCallback(){
        this.header = this.closest('.section-header') || getHeaderRoot() || document.querySelector('.section-header');
        if (!this.header) return;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        if (this.headerIsAlwaysSticky){ this.header.classList.add('shopify-section-header-sticky'); }
        this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
      disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
      createObserver(){ let o = new IntersectionObserver((e,ob)=>{ this.headerBounds = e[0].intersectionRect; ob.disconnect(); }); o.observe(this.header); }
      onScroll(){
        const y = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (y > this.currentScrollTop && y > this.headerBounds.bottom){ this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this)); }
        else if (y < this.currentScrollTop && y > this.headerBounds.bottom){ this.header.classList.add('scrolled-past-header'); if (!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); } else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); } }
        else if (y <= this.headerBounds.top){ this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
        this.currentScrollTop = y;
      }
      hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
      reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
      reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
      closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((d)=>d.close()); }
      closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal && this.searchModal.close(false); }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  const getActiveHeaderRoot = () => getHeaderRoot() || document.querySelector('.section-header');
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  const applyPillLayout = () => {
    const shell = getActiveHeaderRoot();
    if (!shell) return;

    const header = shell.querySelector('.header');
    if (!header) return;

    const menuSkin = header.querySelector('.as-menu-skin');
    const inlineMenu = menuSkin && menuSkin.querySelector('.header__inline-menu');
    const logoWrapper = header.querySelector('.header__heading');
    const logoLink = header.querySelector('.header__heading-link');
    const logoNode = logoWrapper || logoLink;
    const iconsContainer = header.querySelector('.header__icons');
    const ctas = header.querySelector('.as-header-ctas');
    const account = header.querySelector('.header__icon--account');
    const cart = header.querySelector('#cart-icon-bubble');

    if (!menuSkin || !inlineMenu || !logoNode || !iconsContainer) return;

    if (!mqDesktop.matches) {
      if (logoNode.parentElement !== header) {
        header.insertBefore(logoNode, menuSkin);
        logoNode.classList.remove('as-pill-logo');
      }
      if (ctas && !iconsContainer.contains(ctas)) {
        iconsContainer.insertBefore(ctas, iconsContainer.firstChild);
      }
      if (account && !iconsContainer.contains(account)) {
        iconsContainer.appendChild(account);
        account.classList.remove('as-pill-account');
      }
      if (cart && !iconsContainer.contains(cart)) {
        iconsContainer.appendChild(cart);
        cart.classList.remove('as-pill-cart');
      }
      return;
    }

    if (!inlineMenu.contains(logoNode)) {
      inlineMenu.insertBefore(logoNode, inlineMenu.firstChild);
      logoNode.classList.add('as-pill-logo');
    }
    if (ctas && !inlineMenu.contains(ctas)) {
      inlineMenu.appendChild(ctas);
    }
    if (account && !inlineMenu.contains(account)) {
      inlineMenu.appendChild(account);
      account.classList.add('as-pill-account');
    }
    if (cart && !inlineMenu.contains(cart)) {
      inlineMenu.appendChild(cart);
      cart.classList.add('as-pill-cart');
    }
  };

  const bindDrawerMegaGuards = () => {
    const root = getActiveHeaderRoot();
    if (!root || root.dataset.asDrawerGuardInit === '1') return;
    root.dataset.asDrawerGuardInit = '1';

    const drawer = root.querySelector('header-drawer details')
      || root.querySelector('.menu-drawer-container details')
      || root.querySelector('details[role="dialog"]');
    const megas = Array.from(root.querySelectorAll('.as-menu-skin .mega-menu'));

    const closeMegas = () => megas.forEach((d) => {
      try { d.open = false; } catch (e) {}
    });
    const closeDrawer = () => {
      if (!drawer) return;
      try { drawer.open = false; } catch (e) {}
      drawer.removeAttribute('open');
      const sum = drawer.querySelector('summary');
      if (sum) sum.setAttribute('aria-expanded', 'false');
    };

    if (drawer) drawer.addEventListener('toggle', () => { if (drawer.open) closeMegas(); });
    megas.forEach((m) => m.addEventListener('toggle', () => { if (m.open) closeDrawer(); }));
    mqDesktop.addEventListener('change', (event) => {
      if (event.matches) closeDrawer();
      else closeMegas();
    });
  };

  const bindDesktopHoverUnfold = () => {
    const root = getActiveHeaderRoot();
    if (!root) return;

    const allMenuDetails = Array.from(root.querySelectorAll('.as-menu-skin details'));

    const closeDetailTree = (detail) => {
      detail.querySelectorAll('details[open]').forEach((nested) => {
        try { nested.open = false; } catch (e) {}
      });
      try { detail.open = false; } catch (e) {}
    };

    const closeSiblingDetails = (detail) => {
      const parent = detail.parentElement;
      if (!parent) return;
      Array.from(parent.children).forEach((sibling) => {
        if (sibling === detail) return;
        if (!(sibling instanceof HTMLElement)) return;
        if (sibling.tagName !== 'DETAILS') return;
        if (!sibling.open) return;
        closeDetailTree(sibling);
      });
    };

    allMenuDetails.forEach((detail) => {
      if (!(detail instanceof HTMLElement)) return;
      if (detail.dataset.asHoverUnfoldBound === '1') return;
      detail.dataset.asHoverUnfoldBound = '1';

      let closeTimer = null;

      const cancelClose = () => {
        if (!closeTimer) return;
        window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const openOnHover = () => {
        if (!mqDesktop.matches) return;
        cancelClose();
        closeSiblingDetails(detail);
        try { detail.open = true; } catch (e) {}
      };

      const closeOnLeave = () => {
        if (!mqDesktop.matches) return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          closeDetailTree(detail);
        }, 140);
      };

      detail.addEventListener('mouseenter', openOnHover);
      detail.addEventListener('mouseleave', closeOnLeave);
      detail.addEventListener('focusin', openOnHover);
      detail.addEventListener('focusout', (event) => {
        if (detail.contains(event.relatedTarget)) return;
        closeOnLeave();
      });
    });

    if (root.dataset.asHoverUnfoldMqBound !== '1') {
      root.dataset.asHoverUnfoldMqBound = '1';
      mqDesktop.addEventListener('change', (event) => {
        if (event.matches) return;
        root.querySelectorAll('.as-menu-skin details[open]').forEach((detail) => {
          try { detail.open = false; } catch (e) {}
        });
      });
    }
  };

  const initFreightQuoteForm = (popup) => {
    if (!popup) return;
    const sid  = popup.dataset.fqSection || '';
    const wrap = popup.querySelector(`#as-fq-wrap-${sid}`);
    if (!wrap || wrap.dataset.asFqReady === '1') return;
    wrap.dataset.asFqReady = '1';

    const form      = popup.querySelector(`#as-fq-form-${sid}`);
    // Variant ID map for Add to Cart (fans/MUA hardcoded, hoods from product settings)
    let variantData = {};
    try { const r = form && form.dataset.fqVariants; if (r) variantData = JSON.parse(r); } catch(e) {}
    const matchVariant = (type, key) => {
      const variants = variantData[type] || [];
      if (!variants.length) return null;
      if (type === 'mua') return variants[0];
      const k = String(key).toLowerCase().replace(/[^a-z0-9]/g, '');
      return variants.find(v => {
        const opts = [v.o1, v.o2].filter(Boolean);
        return opts.some(o => { const n = String(o).toLowerCase().replace(/[^a-z0-9]/g,''); return n === k || n.includes(k) || k.includes(n); });
      }) || null;
    };
    let lastItems = [];

    // Per-row live price lookup — shows line total (qty × unit price)
    const priceCache = new Map();
    const renderRowPrice = (row) => {
      const priceEl = row.querySelector('.as-fq-row-price');
      const qtyEl   = row.querySelector('input[type="number"]');
      if (!priceEl || !priceEl.dataset.unitPrice) return;
      const unit = parseFloat(priceEl.dataset.unitPrice);
      const qty  = parseInt(qtyEl ? qtyEl.value : '1') || 1;
      priceEl.textContent = `$${(unit * qty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      priceEl.className = 'as-fq-row-price';
    };
    const fetchRowPrice = async (row) => {
      const typeSel = row.querySelector('.as-fq-type-sel');
      const sizeSel = row.querySelector('.as-fq-size-sel');
      const priceEl = row.querySelector('.as-fq-row-price');
      if (!priceEl) return;
      const type    = typeSel ? typeSel.value : 'hood';
      const sizeKey = type === 'mua' ? 'mua' : (sizeSel ? sizeSel.value : '');
      if (!sizeKey) { priceEl.textContent = '—'; priceEl.className = 'as-fq-row-price'; delete priceEl.dataset.unitPrice; return; }
      const v = matchVariant(type, sizeKey);
      if (!v) { priceEl.textContent = '—'; priceEl.className = 'as-fq-row-price'; delete priceEl.dataset.unitPrice; return; }
      if (priceCache.has(v.id)) {
        priceEl.dataset.unitPrice = priceCache.get(v.id);
        renderRowPrice(row);
        return;
      }
      priceEl.textContent = '…';
      priceEl.className = 'as-fq-row-price as-fq-row-price--loading';
      delete priceEl.dataset.unitPrice;
      try {
        const resp = await fetch(`/variants/${v.id}.js`);
        if (!resp.ok) throw new Error();
        const vData = await resp.json();
        const price = Number(vData.price) / 100;
        priceCache.set(v.id, price);
        priceEl.dataset.unitPrice = price;
        renderRowPrice(row);
      } catch(e) {
        priceEl.textContent = '—';
        priceEl.className = 'as-fq-row-price';
        delete priceEl.dataset.unitPrice;
      }
    };

    const loadingEl = popup.querySelector(`#as-fq-loading-${sid}`);
    const resultEl  = popup.querySelector(`#as-fq-result-${sid}`);
    const rowsEl    = popup.querySelector(`#as-fq-rows-${sid}`);
    const addBtn    = popup.querySelector(`#as-fq-add-${sid}`);
    const page1     = popup.querySelector(`#as-fq-page1-${sid}`);
    const page2     = popup.querySelector(`#as-fq-page2-${sid}`);
    const stepsEl   = popup.querySelector(`#as-fq-steps-${sid}`);
    const stepDots  = stepsEl ? stepsEl.querySelectorAll('.as-fq-step') : [];

    const setStep = (n) => {
      stepDots.forEach((s) => {
        const sn = parseInt(s.dataset.step);
        s.className = 'as-fq-step' + (sn === n ? ' as-fq-step--active' : sn < n ? ' as-fq-step--done' : '');
      });
    };

    const showView = (v) => {
      if (form)      form.hidden      = v !== 'form' && v !== 'step1' && v !== 'step2';
      if (loadingEl) loadingEl.hidden = v !== 'loading';
      if (resultEl)  resultEl.hidden  = v !== 'result';
      if (stepsEl)   stepsEl.hidden   = v === 'loading' || v === 'result';
      if (page1)     page1.hidden     = v !== 'form' && v !== 'step1';
      if (page2)     page2.hidden     = v !== 'step2';
      if (v === 'form' || v === 'step1') setStep(1);
      else if (v === 'step2') setStep(2);
      else if (v === 'result') setStep(3);
    };
    showView('form');

    // Step navigation
    form && form.addEventListener('click', (e) => {
      const nextBtn = e.target.closest('[data-fq-next]');
      if (!nextBtn) return;
      const target = nextBtn.dataset.fqNext;
      if (target === '2') showView('step2');
      else if (target === '1') showView('step1');
    });

    const HOOD_OPTS = '<option value="">Select size</option><option value="4">4 ft</option><option value="5">5 ft</option><option value="6">6 ft</option><option value="8">8 ft</option><option value="10">10 ft</option><option value="12">12 ft</option>';
    const FAN_OPTS  = '<option value="">Select model</option><option value="duc1010">DUC1010</option><option value="duc1212">DUC1212</option><option value="duc1214">DUC1214</option>';
    const KIT_OPTS  = '<option value="">Select kit</option><option value="kit6ftduc1010">6 ft Hood + DUC1010 Fan</option>';

    const updateRowSize = (row, type) => {
      const sizeField = row.querySelector('.as-fq-field--size');
      const sizeSel   = row.querySelector('.as-fq-size-sel');
      const sizeLabel = sizeField && sizeField.querySelector('.as-fq-label');
      if (!sizeField) return;
      if (!type || type === '') {
        sizeField.hidden = true;
        const priceEl = row.querySelector('.as-fq-row-price');
        if (priceEl) { priceEl.textContent = '—'; priceEl.className = 'as-fq-row-price'; delete priceEl.dataset.unitPrice; }
        return;
      }
      if (type === 'mua') {
        sizeField.hidden = true;
        fetchRowPrice(row);
        return;
      }
      sizeField.hidden = false;
      if (sizeSel) sizeSel.innerHTML = type === 'fan' ? FAN_OPTS : type === 'kit' ? KIT_OPTS : HOOD_OPTS;
      if (sizeLabel) sizeLabel.textContent = type === 'fan' ? 'Model' : type === 'kit' ? 'Kit' : 'Size';
      fetchRowPrice(row);
    };

    const syncRemove = () => {
      if (!rowsEl) return;
      const rows = rowsEl.querySelectorAll('.as-fq-row');
      rows.forEach((r) => {
        const rm = r.querySelector('.as-fq-remove');
        if (rm) rm.hidden = rows.length <= 1;
      });
    };

    const bindRowType = (row) => {
      const typeSel = row.querySelector('.as-fq-type-sel');
      const sizeSel = row.querySelector('.as-fq-size-sel');
      const qtyEl   = row.querySelector('input[type="number"]');
      if (typeSel) typeSel.addEventListener('change', () => updateRowSize(row, typeSel.value));
      if (sizeSel) sizeSel.addEventListener('change', () => fetchRowPrice(row));
      if (qtyEl)   qtyEl.addEventListener('input', () => renderRowPrice(row));
    };

    // Initialise existing rows
    if (rowsEl) {
      rowsEl.querySelectorAll('.as-fq-row').forEach((row) => {
        const typeSel = row.querySelector('.as-fq-type-sel');
        updateRowSize(row, typeSel ? typeSel.value : 'hood');
        bindRowType(row);
      });
    }
    syncRemove();

    if (addBtn && rowsEl) {
      addBtn.addEventListener('click', () => {
        const rows = rowsEl.querySelectorAll('.as-fq-row');
        if (rows.length >= 8) return;
        const clone = rows[0].cloneNode(true);
        clone.querySelectorAll('input[type="number"]').forEach((el) => { el.value = '1'; });
        const cloneTypeSel = clone.querySelector('.as-fq-type-sel');
        if (cloneTypeSel) {
          // Add placeholder if not already present
          if (!cloneTypeSel.querySelector('option[value=""]')) {
            cloneTypeSel.insertAdjacentHTML('afterbegin', '<option value="" selected>Select product</option>');
          }
          cloneTypeSel.value = '';
        }
        const cloneSizeField = clone.querySelector('.as-fq-field--size');
        if (cloneSizeField) cloneSizeField.hidden = true;
        const clonePriceEl = clone.querySelector('.as-fq-row-price');
        if (clonePriceEl) { clonePriceEl.textContent = '—'; clonePriceEl.className = 'as-fq-row-price'; delete clonePriceEl.dataset.unitPrice; }
        bindRowType(clone);
        rowsEl.appendChild(clone);
        syncRemove();
      });
    }

    rowsEl && rowsEl.addEventListener('click', (e) => {
      const rm = e.target.closest('.as-fq-remove');
      if (!rm) return;
      const row = rm.closest('.as-fq-row');
      if (row) { row.remove(); syncRemove(); }
    });

    form && form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const proxyUrl = form.dataset.fqProxy;
      if (!proxyUrl) return;

      const zipEl        = popup.querySelector(`#as-fq-zip-${sid}`);
      const zip          = zipEl ? zipEl.value.trim() : '';
      if (zip) localStorage.setItem('as_last_zip', zip);
      const deliveryType = (form.querySelector(`[name="as-fq-delivery-${sid}"]:checked`) || {}).value || 'commercial';
      const liftgate     = (form.querySelector(`[name="as-fq-liftgate-${sid}"]:checked`) || {}).value || 'no';

      const items = [];
      if (rowsEl) {
        rowsEl.querySelectorAll('.as-fq-row').forEach((row) => {
          const typeSel = row.querySelector('.as-fq-type-sel');
          const sizeSel = row.querySelector('.as-fq-size-sel');
          const qtyEl   = row.querySelector('input[type="number"]');
          const type    = typeSel ? typeSel.value : 'hood';
          const qty     = parseInt(qtyEl ? qtyEl.value : '1') || 1;
          if (type === 'mua') {
            items.push({ productType: 'mua', qty });
          } else {
            const size = sizeSel ? sizeSel.value : '';
            if (size) items.push({ productType: type, size, qty });
          }
        });
      }

      if (!items.length) {
        if (resultEl) {
          resultEl.innerHTML = '<div class="as-fq-error">Please select at least one product.</div><div class="as-fq-result-actions"><button type="button" class="as-fq-btn" data-fq-back>← Back</button></div>';
          const backBtn = resultEl.querySelector('[data-fq-back]');
          if (backBtn) backBtn.addEventListener('click', () => showView('step1'));
        }
        showView('result');
        return;
      }

      lastItems = items.slice();
      // Kick off variant price fetches in parallel with the rate request.
      // All types now use direct variant IDs → /variants/[id].js
      const variantFetches = lastItems.map(item => {
        const v = matchVariant(item.productType, item.productType === 'mua' ? 'mua' : item.size);
        if (!v) return Promise.resolve(null);
        return fetch(`/variants/${v.id}.js`).then(r => r.ok ? r.json() : null).catch(() => null);
      });
      showView('loading');
      try {
        const [res, ...variantResponses] = await Promise.all([
          fetch(proxyUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, zip, deliveryType, liftgate }),
          }),
          ...variantFetches,
        ]);
        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.error || 'Could not retrieve rates');

        // Build cart items from resolved variant data — works for all types (hoods use productId fetch)
        const resolvedCartItems = [];
        for (let i = 0; i < lastItems.length; i++) {
          const vData = variantResponses[i];
          if (vData && vData.id) resolvedCartItems.push({ id: Number(vData.id), quantity: lastItems[i].qty });
        }

        const r    = data.cheapest;
        const info = data.shipmentInfo || {};

        // Kick off freight cart prep immediately (update LTL Freight variant price in Shopify)
        const cartPrepUrl = proxyUrl.replace(/\/[^/]+$/, '/freight-cart-prep');
        const freightPrepPromise = fetch(cartPrepUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ freightPrice: r.price }),
        }).then(resp => resp.ok ? resp.json() : null).catch(() => null);
        const transit = r.transitDays
          ? `${r.transitDays} ${r.transitUnit || 'business day(s)'}`
          : 'Transit time unavailable';
        const noteParts = [
          info.itemsSummary || null,
          info.palletCount > 0 ? `${info.palletCount} pallet${info.palletCount > 1 ? 's' : ''}` : null,
          info.totalWeight  ? `${info.totalWeight} lbs` : null,
          zip               ? `to zip ${zip}` : null,
        ].filter(Boolean);

        // Build price breakdown from variant API responses
        const priceLines = [];
        let productSubtotal = 0;
        let hasPrices = false;
        for (let i = 0; i < lastItems.length; i++) {
          const item = lastItems[i];
          const vData = variantResponses[i];
          // Shopify returns price as a string ("2990") or integer — handle both
          if (!vData || vData.price == null) continue;
          hasPrices = true;
          const unitPrice = Number(vData.price) / 100;
          const lineTotal = unitPrice * item.qty;
          productSubtotal += lineTotal;
          const sizeLabel = (item.productType === 'mua' || item.productType === 'kit') ? '' : ` (${item.size}${item.productType === 'hood' ? ' ft' : ''})`;
          const typeName  = item.productType === 'hood' ? 'Exhaust Hood' : item.productType === 'fan' ? 'Exhaust Fan' : item.productType === 'kit' ? '6 ft Hood + DUC1010 Fan Kit' : 'Make-Up Air';
          priceLines.push(`<div class="as-fq-price-line"><span>${typeName}${sizeLabel} &times; ${item.qty}</span><span>$${lineTotal.toFixed(2)}</span></div>`);
        }

        let summaryHtml = '';
        if (hasPrices) {
          const freightPrice = r.price;
          const estimatedTotal = productSubtotal + freightPrice;
          summaryHtml = `<div class="as-fq-order-summary">
            ${priceLines.join('')}
            ${priceLines.length > 1 ? `<div class="as-fq-price-line as-fq-price-sub"><span>Products subtotal</span><span>$${productSubtotal.toFixed(2)}</span></div>` : ''}
            <div class="as-fq-price-line as-fq-price-freight"><span>Est. freight (${r.carrier})</span><span>$${freightPrice.toFixed(2)}</span></div>
            <div class="as-fq-price-line as-fq-price-total"><span>Estimated total</span><span>$${estimatedTotal.toFixed(2)}</span></div>
            <p class="as-fq-carrier-note">${transit}${noteParts.length ? ' &middot; ' + noteParts.join(' &middot; ') : ''}</p>
          </div>`;
        } else {
          summaryHtml = `<div class="as-fq-rate-card">
            <p class="as-fq-rate-carrier">${r.carrier}</p>
            <p class="as-fq-rate-price">${r.currency || '$'}${r.price.toFixed(2)}</p>
            <p class="as-fq-rate-transit">${transit}</p>
            ${noteParts.length ? `<p class="as-fq-rate-note">${noteParts.join(' · ')}</p>` : ''}
          </div>`;
        }

        if (resultEl) resultEl.innerHTML = `
          ${summaryHtml}
          <div class="as-fq-result-actions">
            <button type="button" class="as-fq-btn as-fq-btn--primary as-fq-btn--atc" data-fq-add-cart>Add to Cart</button>
            <div class="as-fq-result-meta">
              <button type="button" class="as-fq-btn" data-fq-back>← Modify</button>
              <button type="button" class="as-fq-btn as-fq-btn--cancel" data-close-quote-popup>Close</button>
            </div>
          </div>`;
        showView('result');
        const backBtn = resultEl.querySelector('[data-fq-back]');
        if (backBtn) backBtn.addEventListener('click', () => showView('step1'));
        const atcBtn = resultEl.querySelector('[data-fq-add-cart]');
        if (atcBtn) {
          const COLLECTION_MAP = { hood: '/collections/kitchen-and-mobil-kitchen-ventilation', fan: '/collections/upblast-exhaust-fans', mua: '/collections/make-up-air', kit: '/products/6-ft-type-i-hood-2050-cfm-upblast-fan-kit' };
          if (!resolvedCartItems.length) {
            // No variants resolved (e.g. 12ft hood out of stock) — link to collection instead
            const fallbackType = lastItems[0] ? lastItems[0].productType : 'hood';
            atcBtn.textContent = 'Shop Products →';
            atcBtn.addEventListener('click', () => { window.location.href = COLLECTION_MAP[fallbackType] || '/collections/all'; });
          } else {
            atcBtn.addEventListener('click', async () => {
              if (atcBtn.dataset.fqAtcState === 'done') { window.location.href = '/cart'; return; }
              atcBtn.disabled = true;
              atcBtn.textContent = 'Adding…';
              try {
                // Wait for freight cart prep (sets LTL Freight variant price)
                const freightPrep = await freightPrepPromise;
                const allCartItems = [...resolvedCartItems];
                if (freightPrep && freightPrep.variantId) {
                  allCartItems.push({ id: freightPrep.variantId, quantity: 1 });
                }
                const cr = await fetch('/cart/add.js', {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: allCartItems }),
                });
                if (!cr.ok) {
                  const errData = await cr.json().catch(() => ({}));
                  throw new Error(errData.description || errData.message || `Error ${cr.status}`);
                }
                atcBtn.textContent = 'Added ✓';
                atcBtn.style.cssText = 'background:#2a7a2a;border-color:#2a7a2a';
                fetch('/cart.js').then(r2 => r2.json()).then(cart => {
                  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                  if (bubble) { const sp = bubble.querySelector('[aria-hidden]'); if (sp) sp.textContent = cart.item_count; }
                  else if (cart.item_count > 0) {
                    const icon = document.querySelector('#cart-icon-bubble');
                    if (icon) icon.insertAdjacentHTML('beforeend', `<div class="cart-count-bubble"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span></div>`);
                  }
                  // Update forklift box count
                  const fk = document.querySelector('.as-forklift-icon');
                  if (fk) {
                    const prev = parseInt(fk.dataset.count) || 0;
                    const next = Math.min(cart.item_count, 5);
                    fk.dataset.count = next;
                    if (next > prev) {
                      const newBox = fk.querySelector(`[data-box="${next}"]`);
                      if (newBox) { newBox.classList.add('as-fk-box--new'); setTimeout(() => newBox.classList.remove('as-fk-box--new'), 400); }
                    }
                  }
                }).catch(()=>{});
                window.setTimeout(() => {
                  atcBtn.style.cssText = '';
                  atcBtn.textContent = 'View Cart →';
                  atcBtn.disabled = false;
                  atcBtn.dataset.fqAtcState = 'done';
                }, 1200);
              } catch(err2) {
                atcBtn.textContent = 'Add to Cart';
                atcBtn.disabled = false;
                const existingErr = resultEl.querySelector('.as-fq-atc-error');
                if (existingErr) existingErr.remove();
                const errEl = document.createElement('p');
                errEl.className = 'as-fq-atc-error';
                errEl.style.cssText = 'font-size:0.85rem;color:#cc4040;margin:4px 0 0;text-align:center';
                errEl.textContent = err2.message || 'Could not add to cart — try again.';
                atcBtn.parentNode.insertBefore(errEl, atcBtn.nextSibling);
              }
            });
          }
        }
      } catch (err) {
        if (resultEl) resultEl.innerHTML = `
          <div class="as-fq-error">${err.message || 'Something went wrong. Please try again.'}</div>
          <div class="as-fq-result-actions">
            <button type="button" class="as-fq-btn" data-fq-back>← Back</button>
          </div>`;
        showView('result');
        const backBtn = resultEl.querySelector('[data-fq-back]');
        if (backBtn) backBtn.addEventListener('click', () => showView('step2'));
      }
    });

    popup.__asFqReset = () => { showView('step1'); if (resultEl) resultEl.innerHTML = ''; };
  };

  const openQuotePopup = (popup, opener) => {
    if (!popup) return;
    if (opener) popup.__asLastOpener = opener;

    initFreightQuoteForm(popup);
    if (typeof popup.__asFqReset === 'function') popup.__asFqReset();

    // Restore saved zip if no Shopify address pre-filled it
    const sid = popup.dataset.fqSection || '';
    const zipEl = popup.querySelector(`#as-fq-zip-${sid}`);
    if (zipEl && !zipEl.value) {
      const saved = localStorage.getItem('as_last_zip');
      if (saved) zipEl.value = saved;
    }

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    const focusTarget = popup.querySelector('select, input:not([type="radio"]), button');
    if (focusTarget) focusTarget.focus();
  };

  const closeQuotePopup = (popup) => {
    if (!popup) return;
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (popup.__asLastOpener && typeof popup.__asLastOpener.focus === 'function') {
      popup.__asLastOpener.focus();
    }
  };

  const hydrateQuotePopupState = () => {
    const root = getActiveHeaderRoot();
    if (!root) return;
    const popup = root.querySelector('[data-quote-popup]');
    if (!popup) return;
    initFreightQuoteForm(popup);
  };

  const runHeaderHydration = () => {
    bindDrawerMegaGuards();
    bindDesktopHoverUnfold();
    applyPillLayout();
    hydrateQuotePopupState();
  };

  const observeHeaderMutations = () => {
    const root = getActiveHeaderRoot();
    if (!root || root.dataset.asHeaderObserverInit === '1') return;
    root.dataset.asHeaderObserverInit = '1';

    let frame = null;
    const observer = new MutationObserver(() => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        runHeaderHydration();
      });
    });
    observer.observe(root, { childList: true, subtree: true });
  };

  if (!window.__asHeaderRuntime) window.__asHeaderRuntime = {};
  var asHeaderRuntimeKey = getHeaderRuntimeKey();
  if (!window.__asHeaderRuntime[asHeaderRuntimeKey]) {
    window.__asHeaderRuntime[asHeaderRuntimeKey] = true;

    runHeaderHydration();
    observeHeaderMutations();
    window.addEventListener('resize', runHeaderHydration);
    mqDesktop.addEventListener('change', runHeaderHydration);

    const rerenderHydrate = () => {
      if (!getActiveHeaderRoot()) return;
      window.requestAnimationFrame(() => {
        runHeaderHydration();
        observeHeaderMutations();
        window.setTimeout(runHeaderHydration, 80);
      });
    };
    document.addEventListener('shopify:section:load', rerenderHydrate);
    document.addEventListener('shopify:section:select', rerenderHydrate);
    document.addEventListener('shopify:block:select', rerenderHydrate);
  }

  if (!window.__asHeaderSearchOpenerBound) {
    window.__asHeaderSearchOpenerBound = true;
    document.addEventListener('click', (event) => {
      const opener = event.target && event.target.closest('[data-open-header-search]');
      if (!opener) return;

      const shell = opener.closest('.section-header') || getActiveHeaderRoot();
      if (!shell) return;

      const summary = shell.querySelector('.header__search summary');
      if (!summary) return;

      event.preventDefault();
      summary.click();
      window.setTimeout(() => {
        const input = shell.querySelector('#Search-In-Modal');
        if (input) input.focus();
      }, 40);
    });
  }

  if (!window.__asQuotePopupBindings) {
    window.__asQuotePopupBindings = true;

    document.addEventListener('click', (event) => {
      const opener = event.target && event.target.closest('[data-open-quote-popup]');
      if (opener) {
        const shell = opener.closest('.section-header') || getActiveHeaderRoot();
        const popup = shell && shell.querySelector('[data-quote-popup]');
        if (!popup) return;
        event.preventDefault();
        openQuotePopup(popup, opener);

        // Pre-select product type and size/model if opener specifies them
        const preselect = opener.dataset.fqProductType;
        if (preselect) {
          const firstRow = popup.querySelector('.as-fq-row');
          if (firstRow) {
            const typeSel = firstRow.querySelector('.as-fq-type-sel');
            if (typeSel && typeSel.value !== preselect) {
              typeSel.value = preselect;
              typeSel.dispatchEvent(new Event('change'));
            }
            // Set size/model after type change updates the dropdown options
            const preselectSize = opener.dataset.fqSize;
            if (preselectSize) {
              setTimeout(() => {
                const sizeSel = firstRow.querySelector('.as-fq-size-sel');
                if (sizeSel) {
                  sizeSel.value = preselectSize;
                  sizeSel.dispatchEvent(new Event('change'));
                }
              }, 50);
            }
          }
        }
        return;
      }

      const closer = event.target && event.target.closest('[data-close-quote-popup]');
      if (!closer) return;
      const popup = closer.closest('[data-quote-popup]');
      if (!popup) return;
      event.preventDefault();
      closeQuotePopup(popup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const popup = document.querySelector('.as-quote-popup:not([hidden])');
      if (!popup) return;
      closeQuotePopup(popup);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-dock-airsupply"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const qs = (s, r=document) => r.querySelector(s);
    const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

    const backdrop = qs('[data-as-backdrop]');
    const panels = qsa('.as-panel');
    const toggles = qsa('[data-as-toggle]');
    const accs = qsa('[data-as-accordion]');

    function closeAllPanels(){
      panels.forEach(p => p.classList.remove('is-open'));
      toggles.forEach(t => t.setAttribute('aria-expanded','false'));
      backdrop && backdrop.classList.remove('is-open');
    }

    // Open a panel
    toggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-as-toggle');
        const panel = id && document.getElementById(id);
        if (!panel) return;

        const isOpen = panel.classList.contains('is-open');
        closeAllPanels();
        if (!isOpen){
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
          backdrop && backdrop.classList.add('is-open');
        }
      }, { passive:false });
    });

    // Close panel actions
    backdrop && backdrop.addEventListener('click', closeAllPanels);
    qsa('[data-as-close]').forEach(x => x.addEventListener('click', closeAllPanels));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllPanels(); });

    // Accordion (level 1 → level 2) and (level 2 → level 3)
    accs.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const base = btn.getAttribute('data-as-accordion');
        const list = document.getElementById(base + '-list');
        if (!list) return;
        const open = list.classList.contains('is-open');
        // close siblings at same level
        const container = btn.closest('.as-panel__scroll') || btn.closest('.as-sublist') || btn.closest('.as-subsublist');
        if (container){
          Array.from(container.querySelectorAll('.as-sublist, .as-subsublist')).forEach(el => {
            if (el !== list) el.classList.remove('is-open');
          });
          Array.from(container.querySelectorAll('[data-as-accordion]')).forEach(el => {
            if (el !== btn) el.setAttribute('aria-expanded','false');
          });
        }
        // toggle current
        if (open){
          list.classList.remove('is-open');
          btn.setAttribute('aria-expanded','false');
        } else {
          list.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
        }
      }, { passive:false });
    });
  });

  // Cart badge: refresh when cart changes (covers Dawn cart-add events + manual fetches)
  (function(){
    var cartLinks = document.querySelectorAll('.as-dock a[data-cart-link]');
    if (!cartLinks.length) return;
    function setCount(n){
      cartLinks.forEach(function(a){ a.setAttribute('data-cart-count', String(n || 0)); });
    }
    function refresh(){
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c) setCount(c.item_count); })
        .catch(function(){});
    }
    // Listen for Dawn's PUB/SUB cart events if available
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:update', refresh);
    // Also patch fetch to detect /cart/add, /cart/change, /cart/update calls
    var origFetch = window.fetch;
    if (origFetch && !window.__asDockCartPatched) {
      window.__asDockCartPatched = true;
      window.fetch = function(input, init){
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(refresh).catch(function(){});
        }
        return p;
      };
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WIZARD_SELECTOR = '[data-rq-wizard]';
    const STEP_SELECTOR = '[data-rq-step]';
    const STEP_CHIP_SELECTOR = '[data-rq-chip]';
    const PROGRESS_SELECTOR = '[data-rq-progress]';
    const PREV_SELECTOR = '[data-rq-prev]';
    const NEXT_SELECTOR = '[data-rq-next]';
    const SUBMIT_SELECTOR = '[data-rq-submit]';
    const CONTROL_SELECTOR = 'input, select, textarea';

    const isFieldControl = (element) => {
      if (!element) return false;
      if (element.type === 'hidden') return false;
      if (element.tagName === 'BUTTON') return false;
      return true;
    };

    const getControls = (scope) => {
      return Array.from(scope.querySelectorAll(CONTROL_SELECTOR)).filter(isFieldControl);
    };

    const initWizard = (wizard) => {
      if (!wizard || wizard.dataset.rqWizardReady === '1') return;

      const form = wizard.closest('form');
      const steps = Array.from(wizard.querySelectorAll(STEP_SELECTOR));
      const chips = Array.from(wizard.querySelectorAll(STEP_CHIP_SELECTOR));
      const progressBar = wizard.querySelector(PROGRESS_SELECTOR);
      const prevButton = wizard.querySelector(PREV_SELECTOR);
      const nextButton = wizard.querySelector(NEXT_SELECTOR);
      const submitButton = wizard.querySelector(SUBMIT_SELECTOR);

      if (!form || !steps.length || !prevButton || !nextButton || !submitButton) return;

      let activeStep = 0;
      wizard.dataset.rqWizardReady = '1';

      const syncState = () => {
        const totalSteps = steps.length;
        const progress = ((activeStep + 1) / totalSteps) * 100;

        steps.forEach((step, index) => {
          const isActive = index === activeStep;
          step.classList.toggle('is-active', isActive);
          step.hidden = !isActive;
          step.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          getControls(step).forEach((control) => {
            control.disabled = !isActive;
          });
        });

        chips.forEach((chip, index) => {
          chip.classList.toggle('is-active', index === activeStep);
        });

        if (progressBar) {
          progressBar.style.width = `${progress}%`;
        }

        prevButton.hidden = activeStep === 0;
        nextButton.hidden = activeStep === totalSteps - 1;
        submitButton.hidden = activeStep !== totalSteps - 1;
      };

      const goToStep = (index) => {
        activeStep = Math.max(0, Math.min(index, steps.length - 1));
        syncState();
      };

      const validateActiveStep = () => {
        const controls = getControls(steps[activeStep]);
        const firstInvalid = controls.find((control) => !control.checkValidity());
        if (!firstInvalid) return true;
        firstInvalid.reportValidity();
        return false;
      };

      nextButton.addEventListener('click', () => {
        if (!validateActiveStep()) return;
        goToStep(activeStep + 1);
      });

      prevButton.addEventListener('click', () => {
        goToStep(activeStep - 1);
      });

      form.addEventListener('submit', () => {
        steps.forEach((step) => {
          getControls(step).forEach((control) => {
            control.disabled = false;
          });
        });
      });

      goToStep(0);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(WIZARD_SELECTOR).forEach(initWizard);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
